export const getProp = (prop: string) => (obj: { [key: string]: any }) =>
  obj[prop];
